import React from 'react'
import DashboardIcons from './DashboardIcons';
import { toolTip } from './GlobalActions';

const ActionIcon = (props) => {
    const {isReorderable, handleClick, firstLoad} = props;
  
    return (
        <div>
            {isReorderable ?
                <>
                    <button className='btn btn-outline mr-3' onClick={() => handleClick('CANCEL')}> Cancel</button>
                    <button className='btn btn-outline save' onClick={() => handleClick('SAVE')}> 
                    <img style={{marginRight:'4px'}} src={DashboardIcons.tickIcon}/> Save Changes</button>
                </>
            :   <span className='d-flex today-color align-items-center'>Today
                    {toolTip(
                        <button
                            title='Customize'
                            id="customize"
                            className='icon-squire edit-card ml-2'
                            onClick={() => handleClick()}
                            disabled={firstLoad}>
                            <img className='normal-icon' src={DashboardIcons.editIcon} width={14} height={14} />
                            <img className='hover-icon' src={DashboardIcons.editIconHover} width={14} height={14} />
                        </button>
                    )}
                </span>
            }
        </div>
    )
}

export default ActionIcon